// Google Consent Mode v2 helpers

export const CONSENT_KEY = "ronavirexa_consent_v1";

export const DENIED_CONSENT = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
  functionality_storage: "granted",
  personalization_storage: "denied",
  security_storage: "granted",
};

export const GRANTED_ALL_CONSENT = {
  ad_storage: "granted",
  ad_user_data: "granted",
  ad_personalization: "granted",
  analytics_storage: "granted",
  functionality_storage: "granted",
  personalization_storage: "granted",
  security_storage: "granted",
};

function pushGtag(...args) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag === "function") {
    window.gtag(...args);
  } else {
    window.dataLayer.push(args);
  }
}

export function readSavedConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function persistConsent(state) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      CONSENT_KEY,
      JSON.stringify({
        version: 1,
        savedAt: new Date().toISOString(),
        preferences: state.preferences,
        consent: state.consent,
      })
    );
  } catch (e) {
    // ignore
  }
}

export function preferencesToConsent(prefs) {
  return {
    ad_storage: prefs.ads ? "granted" : "denied",
    ad_user_data: prefs.ads ? "granted" : "denied",
    ad_personalization: prefs.ads ? "granted" : "denied",
    analytics_storage: prefs.analytics ? "granted" : "denied",
    functionality_storage: "granted",
    personalization_storage: prefs.personalization ? "granted" : "denied",
    security_storage: "granted",
  };
}

export function updateConsent(consent) {
  pushGtag("consent", "update", consent);
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "cookie_consent_update" });
  }
}

export function applySavedConsentOnLoad() {
  const saved = readSavedConsent();
  if (saved && saved.consent) {
    updateConsent(saved.consent);
  }
}
